import styled from 'styled-components'

export interface ArrowProps {
  size: number
  direction: 'top' | 'right' | 'bottom' | 'left'
}

export const Arrow = styled.span<ArrowProps>`
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.inverseBg};
  border-right: 1px solid ${({ theme }) => theme.inverseBg};
  transition: 0.2s ease-out;
  ${(props) => {
    switch (props.direction) {
      case 'top':
        return `
          margin-top: 5px;
          transform: rotate(225deg);
        `
      case 'right':
        return `
          transform: rotate(315deg);
          margin-right: 5px;
        `
      case 'bottom':
        return `
          transform: rotate(45deg);
          margin-bottom: 5px;
        `
      case 'left':
        return `
          transform: rotate(135deg);
          margin-left: 5px;
        `
    }
  }}
`
export const FixedColorArrow = styled(Arrow)`
  border-bottom: 1px solid ${({ theme }) => theme.text1};
  border-right: 1px solid ${({ theme }) => theme.text1};
  margin-top: 5px;
  height: 5px;
  width: 5px;
`
